import * as React from 'react'
import { get } from 'lodash'

export default class AddressPicker extends React.Component<any, any>{

    constructor(props){
        super(props)

        this.state = {
            checkedAddresses:null,
            selectedAddress:null,
            selectionMade: false
        }
    }

    
    render(){
        const {
            addresses,
            onSelected,
            onNoAddressSelected,
        } = this.props;


        const onChange = address => e => {
            this.setState({
                ...this.state,
                selectionMade: true,
                selectedAddress: address
            })
        }


        const onClick = e =>{
            this.setState({
                ...this.state,
                checkedAddresses: this.props.addresses,
            })

            if(this.state.selectedAddress == null){
                onNoAddressSelected();
            }else{
                onSelected( this.state.selectedAddress )
            }
        }


        const selection = (address, index) =>{
            return <div><label><input type="radio" key={"address-selection-"+index} id={"address-selection-"+index} name="select-address" onChange={onChange(address)} /> {address.deliveryPoint} {address.streetNumber} {address.streetName} {address.suburb} { address.state} {address.postcode}</label></div>
        }

        //const originalAddress = this.props.originalAddress;

        if(this.props.addresses && this.state.checkedAddresses != this.props.addresses){
            return (
                <div id="suggestedAddresses" className="message">
                    <div className="modal fade show">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h3 className="modal-title">Suggested Addresses</h3>
                                </div>
                                <div className="modal-body">
                                    { addresses.map((address, index) => selection(address, index)) }
                                    <div><label><input type="radio" key={"address-selection-other"} id={"address-selection-other"} name="select-address" onChange={onChange(null)} /> I am unable to find my address</label></div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" disabled={ !this.state.selectionMade } onClick={ onClick.bind(this) }>Select</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            )
        }else{
            return null;
        }
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/address-picker.tsx